import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./ReduxStore/store";
import { LanguageProvider } from "./Pages/Lang/LanguageProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      
        <App />
      
    </React.StrictMode>
  </Provider>
);
